import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { getConnectedDevices, getStatisticMessages } from '@infuse/api/e-connector/statistics';
import { EconnectorStatistics, mapToDomain } from '@infuse/e-connector/dashboard/domain';

export const useStatistics = () => {
  const query = useQuery<EconnectorStatistics>({
    queryKey: ['statistics'],
    queryFn: async () => {
      const [messages, connectedDevices] = await Promise.all([
        getStatisticMessages({}), // past 5 hours only
        getConnectedDevices({})
      ]);
      return mapToDomain(messages, connectedDevices);
    }
  });

  const statistics = computed(() => {
    return (
      query.data.value || {
        centralSystems: { connected: 0, total: 0 },
        chargingStations: { connected: 0, total: 0 },
        messageStatsLast5Hours: []
      }
    ); // to avoid nulls
  });

  return {
    ...query,
    statistics
  };
};
